// Stickers affichés en fond de chaque page (images dans public/images/stickers/).
// Une entrée est sticker('nom') ou { src: sticker('nom'), scale, top, offset }
// pour agrandir un sticker ou forcer sa position (en % de la page / du bord).
// Une page absente de la liste n'a pas de stickers.

const sticker = (name) => `/images/stickers/sticker-${name}.png`;

// L'ordre des pages sert de graine pour le placement : chaque page a sa propre
// disposition. Ajoute les nouvelles pages à la fin pour ne pas décaler les autres.
export const STICKERS_PAR_PAGE = {
  '/notre-histoire': [
    { src: sticker('cisco'), scale: 1.4 },
    sticker('bague'),
    sticker('coeur'),
    sticker('etoile'),
    sticker('tortellini'),
    sticker('hoka'),
    sticker('lunettes'),
    { src: sticker('flasque'), top: 64, offset: 12 },
    sticker('casquette'),
    { src: sticker('van'), scale: 1.4 },
  ],
  '/': [
    sticker('coeur'),
    { src: sticker('van'), scale: 1.4 },
    sticker('etoile'),
    sticker('bague'),
  ],
  '/le-jour-j': [
    sticker('bague'),
    sticker('etoile'),
    sticker('coeur'),
    { src: sticker('carte'), scale: 2 },
  ],
  '/voyage': [
    sticker('tente'),
    sticker('taxi'),
    sticker('voiture'),
    { src: sticker('cff'), scale: 2 },
    sticker('hotel'),
  ],
  '/musique': [
    sticker('orelsan'),
    { src: sticker('taylor'), top: 12 },
    sticker('katy'),
    { src: sticker('abba'), scale: 1.4, top: 62 },
  ],
  '/faq': [
    sticker('robe'),
    sticker('costume'),
    sticker('zzz'),
    sticker('interrogation'),
    sticker('plus-un'),
    sticker('cadeau'),
  ],
  '/rsvp': [
    sticker('cisco2'),
    sticker('hugo'),
    sticker('cisco3'),
  ],
};
